import type { AllRouteEndpoints } from "../routeTypes";
export const engagementReportBuilder2CloneCacheKeys: AllRouteEndpoints[] = ["/engagement/report_builder_2_reports"];
